import { LeadIntent, LeadSource, StatusBadge } from './LeadBadges'
import LeadScore from './LeadScore'
import { fmt } from './LeadTimeline'

/**
 * One lead at a glance: who they are, how to reach them, where they came from and how warm they are.
 * Shared by the Lead Management slide-over panel and the Agent Workspace lead profile, so both show the same facts.
 */
export default function LeadSummary({ lead }) {
  const initial = (lead.name || '?').trim()[0] || '?'
  return (
    <div className="lead-summary">
      <div className="d-flex align-items-center gap-3 mb-3">
        <span className="avatar" style={{ width: 48, height: 48 }} aria-hidden="true">{initial}</span>
        <div className="min-w-0">
          <div className="fw-semibold text-break">{lead.name}</div>
          <StatusBadge status={lead.status} />
        </div>
      </div>
      <dl className="lead-facts">
        <div><dt>Email</dt><dd><a href={`mailto:${lead.email}`} className="text-break">{lead.email}</a></dd></div>
        <div><dt>Phone</dt><dd>{lead.phone ? <a href={`tel:${lead.phone}`}>{lead.phone}</a> : <span className="text-muted">Not given</span>}</dd></div>
        {lead.company && <div><dt>Company</dt><dd className="text-break">{lead.company}</dd></div>}
        <div><dt>Source</dt><dd><LeadSource source={lead.source} /></dd></div>
        <div><dt>Intent</dt><dd><LeadIntent intent={lead.intent} /></dd></div>
        <div><dt>Captured</dt><dd>{fmt(lead.createdAt)}</dd></div>
      </dl>
      {lead.message && <div className="lead-note"><div className="small text-muted mb-1">Message from the visitor</div><div className="text-break">{lead.message}</div></div>}
      <div className="mt-3"><div className="small text-muted mb-1">Lead score</div><LeadScore score={lead.score} /></div>
    </div>
  )
}
